import { useEffect, useState } from "react";
import Seo from "../components/common/Seo";
import HomeHero from "../components/sections/HomeHero";
import Positioning from "../components/sections/Positioning";
import ServiceModules from "../components/sections/ServiceModules";
import AgentFeature from "../components/sections/AgentFeature";
import HowItWorks from "../components/sections/HowItWorks";
import IndustriesGrid from "../components/sections/IndustriesGrid";
import BusinessImpact from "../components/sections/BusinessImpact";
import WhyKratos from "../components/sections/WhyKratos";
import FaqSection from "../components/sections/FaqSection";
import FinalCTA from "../components/sections/FinalCTA";

export default function Home() {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const onReveal = (e) => setRevealed(Boolean(e.detail?.revealed));
    window.addEventListener("kv:hero-reveal", onReveal);
    return () => window.removeEventListener("kv:hero-reveal", onReveal);
  }, []);

  return (
    <>
      <Seo
        title="Kratos Venture Group — Business, reengineered."
        description="Strategy, systems, and intelligent execution. Meet Mythoros — the Kratos Venture Group Desktop AI Agent, an entire digital workforce configured for your business."
        path="/"
      />
      <HomeHero />
      <div
        data-testid="home-sections"
        style={{
          opacity: revealed ? 1 : 0,
          transform: revealed ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 1s ease, transform 1s cubic-bezier(.22,1,.36,1)",
          pointerEvents: revealed ? "auto" : "none",
        }}
      >
        <Positioning />
        <ServiceModules />
        <AgentFeature />
        <HowItWorks />
        <IndustriesGrid />
        <BusinessImpact />
        <WhyKratos />
        <FaqSection />
        <FinalCTA />
      </div>
    </>
  );
}
